import client from '../../client';

const VISITS = {
  getVisits() {
    return client.get(`/buyers/${client.customerId()}/visits`);
  },
}

export default VISITS;
